import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { createValidateSearch } from '@authy/lib-web/routes'

import { rootRoute } from '@/tenant/userManagement/root'

import { SearchSchema, listInvitations } from './routeUtils'

const validateSearch = createValidateSearch(SearchSchema)

export const invitationsRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/invitations',
    component: lazyRouteComponent(() => import('./Invitations'), 'Invitations'),
    validateSearch,
    loaderDeps: ({ search }) => search,
    loader: async ({ abortController, deps, parentMatchPromise }) => {
        await parentMatchPromise
        return await listInvitations(deps, 0, abortController)
    },
})
